import { RR_BASE_URL } from './urls';

export const rrBaseURL = RR_BASE_URL;
